// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IRestoreOfferWebsiteRequest,
  TRestoreOfferWebsiteModel,
  IMappers,
  TRestoreOfferWebsiteResponse,
  IRestoreOfferWebsiteResponse,
  IRestoreOfferWebsiteResponseError,
} from './types';

export const defaultConfig: TRestoreOfferWebsiteModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'hidden-objects',
  pathApi: '/v1/restore-offer-website/',
  requestType: 'json',
} as TRestoreOfferWebsiteModel;

export function createRestoreOfferWebsiteModel(parameters: IRestoreOfferWebsiteRequest): TRestoreOfferWebsiteModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IRestoreOfferWebsiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IRestoreOfferWebsiteRequest;
}

export async function fetchRestoreOfferWebsite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IRestoreOfferWebsiteOptions<TResponse200, TResponse400>): Promise<
  TRestoreOfferWebsiteResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createRestoreOfferWebsiteModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IRestoreOfferWebsiteResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IRestoreOfferWebsiteResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TRestoreOfferWebsiteResponse;
}
